import getLocalString from "constants/Localization";
import { GetDailyFormVehiclesDocument, useCreateDailyFormVehicleMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateDailyFormVehicle() {
  const [mutation, { loading, data, error }] = useCreateDailyFormVehicleMutation({
    refetchQueries: [
      {
        query: GetDailyFormVehiclesDocument,
        variables: {
          first: 50,
          page: 1,
        },
      },
    ],
  });

  const [createDailyFormVehicle, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createDailyFormVehicle",
    },
    {
      successMessage: getLocalString("fleet.create-vehicle-success"),
      failureMessage: getLocalString("fleet.create-vehicle-failure"),
    }
  );

  return [createDailyFormVehicle, context] as const;
}
